import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import { hasAnyPermission } from '../../utils/permissions';

const AuthorizedComponent = (Component, acceptPermissions = []) => {
  const Guarded = ({ permissions }) => {
    const allowed =
      acceptPermissions.length === 0 ||
      hasAnyPermission(permissions, acceptPermissions);
    return allowed ? <Component /> : <Redirect to='/home' />;
  };

  const mapStateToProps = (state) => ({
    permissions: state.auth.auth.details?.permissions || [],
  });

  return connect(mapStateToProps)(Guarded);
};

export default AuthorizedComponent;
